import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import moment from "moment";
import React from 'react';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import { Link } from 'react-router-dom';
import { Guard, Permissions } from '../../role/Guard.jsx';
import { INTEGRATION_KEY } from '../../state/integration/Constants';
import GlobalHelper from '../GlobalHelper.jsx';
import Icon from "../icon/icon.component.jsx";
import PriceListMenuMessage from './PriceListMenuMessage';
import SchedulingMenuMessage from './SchedulingMenuMessage';


const MainMenus = [
    {
        link: '/',
        className: 'menu-dashboard',
        module: "",
        icon: <Icon value="chart-line" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.dashboard"
            defaultMessage="Dashboard"
        />,
        restrictedIntegrations: [],
    },
    {
        link: '/inbox/listing',
        className: 'menu-inbox',
        module: "",
        icon: <Icon value="inbox" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.inbox"
            defaultMessage="Inbox"
        />,
        restrictedIntegrations: [],
        onlyForIntegrations: ['shopify-expert-app', 'shopify'],
    },
    {
        link: '/contacts/listing',
        className: 'menu-contact',
        module: "",
        icon: <Icon value="users" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.contact"
            defaultMessage="Contacts"
        />,
        restrictedIntegrations: [],
    },
    {
        link: '/quotes/listing',
        className: 'menu-quote',
        module: "",
        icon: <Icon value="quote" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.quote"
            defaultMessage="Quotes"
        />,
        restrictedIntegrations: [],
    },
    {
        link: '/price-lists/listing',
        className: 'menu-pricelist',
        module: AccountFeatures.FeaturePriceList,
        icon: <Icon value="shopping-cart" className={"mr-1"} />,
        name: <PriceListMenuMessage />,
        restrictedIntegrations: [],
    },
    {
        link: '/orders/listing',
        className: 'menu-order',
        module: AccountFeatures.FeatureOrder,
        icon: <Icon value="order" style={{ fontSize: '1.10em' }} className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.order"
            defaultMessage="Orders"
        />,
        restrictedIntegrations: ['shopify', 'shopify-expert-app'],
    },
    {
        link: '/invoices/listing',
        module: Features.Invoice,
        className: 'menu-invoice',
        icon: <Icon value="invoice" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.invoice"
            defaultMessage="Invoices"
        />,
        restrictedIntegrations: [],
    },
    {
        link: '/payments/listing',
        module: "",
        className: 'menu-payment',
        icon: <Icon value="dollar-sign" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.payment"
            defaultMessage="Payments"
        />,
        restrictedIntegrations: [],
    },
    {
        link: '/recurring-invoices/listing',
        module: AccountFeatures.FeatureSubscriptions,
        className: 'menu-subscription',
        icon: <Icon value="sync-alt" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.subscription"
            defaultMessage="Subscriptions"
        />,
        restrictedIntegrations: ['shopify', 'shopify-expert-app'],
    },
    {
        link: '/calendar-events/listing',
        className: 'menu-schedulingpage',
        module: AccountFeatures.FeatureScheduling,
        icon: <Icon value="calendar-day" className={"mr-1"} />,
        name: <SchedulingMenuMessage />,
        restrictedIntegrations: [],
    },
    {
        link: '/nylas-migration',
        className: 'menu-nylasmigration',
        module: "",
        icon: <Icon value="exclamation" className={"mr-1"} style={{ color: 'orange' }} />,
        name: <FormattedMessage
            id="main.menu.account_migration_needed"
            defaultMessage="Action required"
        />,
        restrictedIntegrations: [],
        onlyForIntegrations: [INTEGRATION_KEY.NYLAS, INTEGRATION_KEY.NYLASV3],
    }
]
const GetAdminMenus = () => [
    {
        link: '/products/catalog',
        className: 'menu-product',
        module: "",
        icon: <Icon value="tags" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.product"
            defaultMessage="Products"
        />,
    },
    {
        link: AppContext.isInventoryEnabled() ? '/inventory/stock-control' : '/inventory/settings',
        className: 'menu-inventory',
        module: AccountFeatures.FeatureInventory,
        icon: <Icon value="boxes" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.inventory"
            defaultMessage="Inventory"
        />,
        isProtectedOverride: GlobalHelper.hasActiveInventorySync(),
    },
    {
        link: '/payment-processing',
        className: 'menu-payment-processing',
        module: "",
        icon: <Icon value="credit-card" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.payment_processing"
            defaultMessage="Payment Processing"
        />,
        isUSAccount: true
    },
    {
        link: '/branding',
        className: 'menu-sales-tools',
        module: "",
        icon: <Icon value="toolbox" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.sales_tools"
            defaultMessage="Sales tools"
        />,
    },
    {
        link: '/ecommerce-configuration/quote-cart',
        className: 'menu-ecommerce-configuration',
        module: "",
        icon: <Icon value="store" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.ecommerce-configuration"
            defaultMessage="Ecommerce Configuration"
        />,
        onlyForIntegrations: [INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP],

    },
    {
        link: '/settings',
        className: 'menu-account',
        module: "",
        icon: <Icon value="university" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.account"
            defaultMessage="My Account"
        />
    },
    {
        link: '/congrats',
        className: 'start-up-guide',
        module: "",
        icon: <Icon value="info" className={"mr-1"} />,
        name: <FormattedMessage
            id="main.menu.start_up_guide"
            defaultMessage="Start up guide"
        />,
    }
]

const GetMenuPermissions = userRoleKey => {
    switch (userRoleKey) {
        case 'admin':
            return ['menu-dashboard', 'menu-inbox', 'menu-quote', 'menu-order', 'menu-pricelist', 'menu-contact', 'menu-companies', 'menu-order', 'menu-work-order', 'menu-invoice', 'menu-subscription', 'menu-account',
                    'menu-schedulingpage', 'menu-ecommerce-configuration', 'menu-payment', 'menu-payment-processing', 'menu-inventory', 'menu-nylasmigration']
        default:
            return ['menu-dashboard', 'menu-inbox', 'menu-quote', 'menu-order', 'menu-pricelist', 'menu-contact', 'menu-companies', 'menu-order', 'menu-invoice', 'menu-subscription', 'btn btn-primary',
                    'menu-schedulingpage', 'menu-payment', 'menu-nylasmigration']
    }
}

const GetAllowedAdminMenus = () => {
    return GetAdminMenus().filter(m => {
        if (['start-up-guide'].includes(m.className) && window.self === window.top) {
            return false
        }
        if (['start-up-guide'].includes(m.className) && !AppContext.getAccount().attributes.onBoardingStartUpGuideInProgress) {
            return false
        }

        if (['menu-inventory'].includes(m.className) && !Guard.isAuthorized(Permissions.AccessInventory)) {
            return false
        }

        if (m.flag && !GlobalHelper.IsFeatureFlagEnabled(m.flag)) {
            return false
        }

        if (m.isUSAccount && GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()) !== "US") {
            return false
        }

        return true
    })

}

const GetAllowedMenus = () => {
    const user = AppContext.getUserLoggedIn()
    if (!user.id) {
        return []
    }

    return MainMenus.filter(m => {
        if (['menu-inbox'].includes(m.className) && !GlobalHelper.hasShopifyIntegrationWithEnabledInboxFeature()) {
            return false
        }

        if (['menu-subscription', 'menu-order'].includes(m.className) && GlobalHelper.hasShopifyIntegrationWithDisabledFeatures()) {
            return false
        }
        if (GlobalHelper.hasIntegrations(m.restrictedIntegrations)) {
            return false
        }
        const onlyForIntegrations = m.onlyForIntegrations || []
        if (onlyForIntegrations.length > 0 && !GlobalHelper.hasIntegrations(onlyForIntegrations)) {
            return false
        }
        if (m.flag && !GlobalHelper.IsFeatureFlagEnabled(m.flag)) {
            return false
        }

        return GetMenuPermissions(user.attributes.role.attributes.key).filter(c => c === m.className).length > 0

    })
}

const GetMenuAccountStatus = () => {
    let status = ''
    const today = moment()
    const expirationDate = moment(AppContext.getAccount().attributes.expiredAt)
    const accountHasExpired = today > expirationDate

    const accountGracePeriodInDays = AppContext.getAccount().attributes.gracePeriodInDays
    const expirationDatePlusGracePeriod = moment(expirationDate).add(accountGracePeriodInDays, 'days')
    const gracePeriodReached = today > expirationDatePlusGracePeriod

    switch (AppContext.getAccount().attributes.status) {
        case 'demo':
            status = <li className="nav-item embedded text-align-center status-account-demo rounded py-1 d-xl-none">
                <FormattedMessage
                    id="main.menu.status.demo"
                    defaultMessage="Demo account"
                />
            </li>
            break
        case 'trial':
            status = <Link to={'/my-account'} className="btn btn-sm btn-danger mb-0 text-align-center status-account-demo rounded py-1">
                {!accountHasExpired ?
                    <FormattedMessage
                        id="main.menu.status.trial"
                        defaultMessage="Trial ending {relativeDate}"
                        values={{
                            relativeDate: <FormattedRelative value={expirationDate.toDate()} />
                        }}
                    /> :
                    <FormattedMessage
                        id="main.menu.status.trial_select_plan"
                        defaultMessage="Trial expired {relativeDate}.{lineBreak}Select your plan."
                        values={{
                            lineBreak: <br></br>,
                            relativeDate: <FormattedRelative value={expirationDate.toDate()} />
                        }}
                    />
                }
            </Link>
            break
        case 'expired':
            status = <Link to={'/my-account'} className="btn btn-sm btn-danger mb-0 text-align-center status-account-demo rounded py-1">
                {
                    accountHasExpired ?
                        (
                            !gracePeriodReached ?
                                <FormattedMessage
                                    id="main.menu.status.expired_will_be_disabled"
                                    defaultMessage="Your account expired {expirationDate}. It will be disabled {expirationDatePlusGracePeriod}."
                                    values={{
                                        expirationDate: <FormattedRelative value={expirationDate.toDate()} />,
                                        expirationDatePlusGracePeriod: <FormattedRelative value={expirationDatePlusGracePeriod.toDate()} />
                                    }}
                                /> :
                                <FormattedMessage
                                    id="main.menu.status.expired_renew"
                                    defaultMessage="Your account has been disabled. Renew your subscription."
                                />
                        ) :
                        <FormattedMessage
                            id="main.menu.status.expired"
                            defaultMessage="Subscription expiring {relativeDate}"
                            values={{
                                relativeDate: <FormattedRelative value={new Date(AppContext.getAccount().attributes.expiredAt)} />
                            }}
                        />
                }
            </Link>
            break
    }
    return status
}

const GetImpersonation = (impersonation) => {
    if (!impersonation) {
        return ''
    }

    return <li className="nav-item embedded text-align-center impersonation rounded py-1 mb-2 d-xl-none">
        <span className={'menu-text'} >
            <FormattedMessage
                id="main.sidebar.impersonation"
                defaultMessage="Logged as {accountName}"
                values={{
                    accountName: <strong>{impersonation.attributes.companyName}</strong>
                }}
            />
            <br />
            <a href="/impersonate/stop">
                <Icon value="door-closed" />
            </a>
        </span>
    </li>
}

export {
    GetAdminMenus,
    GetAllowedAdminMenus,
    GetAllowedMenus,
    GetImpersonation,
    GetMenuAccountStatus,
    GetMenuPermissions,
    MainMenus
};




// WEBPACK FOOTER //
// ./src/common/layout/menus.jsx